import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa'

import { Container, Content } from './styles';

const Modal = ({ title, buttonLeft, show, onClose, height, width, children }) => {
  const [closed, setClosed] = useState(false)

  const handleClose = () => {
    setClosed(true);
    setTimeout(() => {

      onClose();
      
      setClosed(false);
    }, 500)
  }

  if (!show) {
    return null;
  }

  return (
    <Container >
      <Content closed={closed} style={{height, width}}>
        <button id="exit-button" type="button" onClick={handleClose}>
          <FaTimes size={20}/>
        </button>
        <h1>{title}</h1>

        {children}
      </Content>
    </Container>
  );
}

export default Modal;
